import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';

const PlayerContainer = ({
    container,
}) => (
    <div id={container} className="media-player-wrapper"></div>
);

PlayerContainer.propTypes = {
    container: PropTypes.string.isRequired,
};

export default PlayerContainer;
